import { g as getTranslationComponent } from '../../i18n/FeedbackFormTranslation/index-FZfSYq_3.js';

function internalLoadTranslations(pantherLocale) {
  return getTranslationComponent(pantherLocale);
}

export { internalLoadTranslations as i };
//# sourceMappingURL=internalLoadTranslations-CvbqT5Io.js.map
